export interface PaginatedResponse<T> {
  items: T[]
  total: number
  limit: number
  offset: number
}

export interface GpsSupplyRequest {
  id: string
  distributionId: string
  distributionType: DistributionType
  amount: number
  createdAt: Date
  reviewedAt: Date | null
  reviewedBy: string | null
  reviewStatus: SupplyRequestReviewStatus
  activeFrom: Date
  activeTo: Date
  duration: number
  centerAndRange: {
    center: {
      lat: number
      long: number
    }
    range_meters: number
  }
  drop: Drop
}

export interface Drop {
  id: string
  name: string
  description: string
  imageUrl: string
  eventUrl: string | null
  startDate: Date
  endDate: Date
  timezone: string
  expiryDate: Date
  locationCity: string | null
  locationCountry: string | null
  channel: string | null
  issuerEmail: string
  issuerId: string
}

export enum DistributionType {
  GPS = 'GPS',
}

export enum SupplyRequestReviewStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export interface TableData {
  results: GpsSupplyRequest[]
  meta: {
    total_results: number
    limit: number
    page: number
  }
}

export const isGpsSupplyRequest = (obj: any): obj is GpsSupplyRequest => {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    typeof obj.id === 'string' &&
    typeof obj.distributionId === 'string' &&
    typeof obj.amount === 'number' &&
    obj.drop &&
    typeof obj.drop.id === 'string'
  )
}

export const isDrop = (obj: any): obj is Drop => {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    typeof obj.id === 'string' &&
    typeof obj.name === 'string' &&
    typeof obj.imageUrl === 'string'
  )
}
